import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'
import '@fortawesome/fontawesome-free/css/all.css'

import {vuetify_theme_dark, vuetify_theme_light} from '@/utils/colors'

Vue.use(Vuetify)

export default new Vuetify({
  breakpoint: {
    thresholds: {
      xl: 2048,
      lg: 1680,
      md: 1280,
      sm: 960,
      xs: 512,
      xxs: 0
    }
  },
  icons: {
    iconfont: 'fa'
  },
  theme: {
    dark: true,
    options: {
      customProperties: true
    },
    themes: {
      light: vuetify_theme_light,
      dark: vuetify_theme_dark
    }
  }
})
